(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bst-fabric-guide-nav"] && !Shopify.designMode) return;
  try {
    
  class BstFabricFilter extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick);
      document.addEventListener('shopify:section:select', this.handleSectionSelect);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      document.removeEventListener('shopify:section:select', this.handleSectionSelect);
    }

    handleClick = (event) => {
      const pill = event.target.closest('[data-fabric-filter]');
      if (!pill || !this.contains(pill)) return;
      this.applyFilter(pill.dataset.fabricFilter);
    };

    // Theme editor: never leave the section being edited hidden behind a filter.
    handleSectionSelect = () => {
      this.applyFilter('all');
    };

    applyFilter(filter) {
      const pills = this.querySelectorAll('[data-fabric-filter]');
      const families = document.querySelectorAll('[data-fabric-family]');

      pills.forEach((pill) => {
        pill.setAttribute('aria-pressed', String(pill.dataset.fabricFilter === filter));
      });

      let shown = 0;
      families.forEach((family) => {
        family.hidden = filter !== 'all' && family.dataset.fabricFamily !== filter;
        if (!family.hidden) shown += family.querySelectorAll('.bst-fabric-card').length;
      });

      this.updateEyebrow(filter, shown);
    }

    // "All" restores the customizer eyebrow; any other filter shows "Showing X of Y fabrics".
    updateEyebrow(filter, shown) {
      const eyebrow = this.closest('.bst-fabric-nav')?.querySelector('.bst-fabric-nav__eyebrow');
      if (!eyebrow) return;

      if (filter === 'all') {
        eyebrow.textContent = eyebrow.dataset.defaultText ?? '';
        return;
      }

      const total = document.querySelectorAll('[data-fabric-family] .bst-fabric-card').length;
      eyebrow.textContent = `Showing ${shown} of ${total} ${total === 1 ? 'fabric' : 'fabrics'}`;
    }
  }

  if (!customElements.get('bst-fabric-filter')) {
    customElements.define('bst-fabric-filter', BstFabricFilter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bst-featured-collection"] && !Shopify.designMode) return;
  try {
    
  // snippets/bst-swatches.liquid (rendered with enable_image_preview: true)
  // adds data-image/-srcset/-alt to each swatch from that variant's
  // featured image. assets/bst-shop-all.js has the same hover-swap logic
  // but it's hardcoded to .bst-shop-all-card, a different template's
  // markup, so this section needs its own copy scoped to its own classes.
  (() => {
    const preloadedImageUrls = new Set();

    function preloadImage(url, srcset) {
      if (!url || preloadedImageUrls.has(url)) return;
      preloadedImageUrls.add(url);
      const image = new Image();
      if (srcset) image.srcset = srcset;
      image.src = url;
    }

    function initCard(card) {
      const swatches = card.querySelectorAll('.bst-swatches__item[data-image]');
      const img = card.querySelector('.bst-featured-collection__card-image');
      if (!swatches.length || !img) return;

      const originalSrc = img.currentSrc || img.src;
      const originalSrcset = img.srcset || '';
      const originalAlt = img.alt || '';

      card.addEventListener('pointerenter', () => {
        swatches.forEach(swatch => {
          preloadImage(swatch.getAttribute('data-image'), swatch.getAttribute('data-image-srcset'));
        });
      });

      swatches.forEach(swatch => {
        swatch.addEventListener('pointerenter', () => {
          img.src = swatch.getAttribute('data-image');
          img.srcset = swatch.getAttribute('data-image-srcset') || '';
          img.alt = swatch.getAttribute('data-image-alt') || originalAlt;
        });

        swatch.addEventListener('pointerleave', () => {
          img.src = originalSrc;
          img.srcset = originalSrcset;
          img.alt = originalAlt;
        });
      });
    }

    document.querySelectorAll('.bst-featured-collection__card').forEach(initCard);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bst-size-chart"] && !Shopify.designMode) return;
  try {
    
  class BstSizeChart extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.#handleClick.bind(this));

      this.rows = this.querySelectorAll('[data-bst-scroll]');
      for (const row of this.rows) {
        this.#initDragScroll(row);
      }
    }

    #handleClick(event) {
      const genderButton = event.target.closest('[data-gender-toggle]');
      if (genderButton) {
        const gender = genderButton.dataset.genderToggle;

        for (const btn of this.querySelectorAll('[data-gender-toggle]')) {
          const isActive = btn === genderButton;
          btn.classList.toggle('is-active', isActive);
          btn.setAttribute('aria-pressed', String(isActive));
        }

        for (const category of this.querySelectorAll('[data-gender]')) {
          category.hidden = category.dataset.gender !== gender;
        }
        return;
      }

      const button = event.target.closest('[data-unit-toggle]');
      if (! button) return;
      


      const scope = button.closest('.bst-size-chart__category');
      if (! scope) return;
      


      const unit = button.dataset.unitToggle;

      for (const btn of scope.querySelectorAll('[data-unit-toggle]')) {
        const isActive = btn === button;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', String(isActive));
      }

      for (const el of scope.querySelectorAll('[data-unit]')) {
        el.hidden = el.dataset.unit !== unit;
      }
    }

    #initDragScroll(row) {
      let isDown = false;
      let startX = 0;
      let startScrollLeft = 0;

      row.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch') return;
        


        isDown = true;
        startX = event.clientX;
        startScrollLeft = row.scrollLeft;
        row.setPointerCapture(event.pointerId);
        row.setAttribute('dragging', '');
      });

      row.addEventListener('pointermove', (event) => {
        if (! isDown) return;
        


        row.scrollLeft = startScrollLeft - (event.clientX - startX);
      });

      const stopDrag = () => {
        isDown = false;
        row.removeAttribute('dragging');
      };

      row.addEventListener('pointerup', stopDrag);
      row.addEventListener('pointercancel', stopDrag);
      row.addEventListener('pointerleave', stopDrag);
    }
  }

  customElements.define('bst-size-chart', BstSizeChart);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-products-tabs')) {
    class FeaturedProductsTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.tabs.forEach((tab) => tab.addEventListener('click', () => this.activate(tab)));
        if (this.tabs.length) this.activate(this.tabs[0]);

        this.addEventListener('pointerover', (event) => {
          this.preloadSwatchImages(event);
          this.previewSwatchImage(event);
        });
        this.addEventListener('pointerout', (event) => this.resetSwatchImage(event));
      }

      preloadSwatchImages(event) {
        const details = event.target.closest('.bst-featured-products__details');
        if (!details || details.contains(event.relatedTarget) || details.dataset.preloaded) return;

        details.dataset.preloaded = 'true';
        details.querySelectorAll('.bst-swatches__item[data-image]').forEach((swatch) => {
          const image = new Image();
          image.src = swatch.dataset.image;
        });
      }

      activate(tab) {
        this.tabs.forEach((t) => {
          const active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active);
        });
        this.panels.forEach((panel) => {
          const active = panel.id === tab.getAttribute('aria-controls');
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      }

      previewSwatchImage(event) {
        const swatch = event.target.closest('.bst-swatches__item');
        if (!swatch || !swatch.dataset.image) return;

        const image = swatch.closest('.bst-featured-products__card')?.querySelector('.bst-featured-products__image');
        if (!image) return;

        if (image.dataset.originalSrc === undefined) {
          image.dataset.originalSrc = image.src;
          image.dataset.originalSrcset = image.srcset;
          image.dataset.originalAlt = image.alt;
        }

        image.src = swatch.dataset.image;
        image.srcset = swatch.dataset.imageSrcset || '';
        image.alt = swatch.dataset.imageAlt || image.dataset.originalAlt;
      }

      resetSwatchImage(event) {
        const swatch = event.target.closest('.bst-swatches__item');
        if (!swatch || swatch.contains(event.relatedTarget)) return;

        const image = swatch.closest('.bst-featured-products__card')?.querySelector('.bst-featured-products__image');
        if (!image || image.dataset.originalSrc === undefined) return;

        image.src = image.dataset.originalSrc;
        image.srcset = image.dataset.originalSrcset;
        image.alt = image.dataset.originalAlt;
      }
    }

    customElements.define('featured-products-tabs', FeaturedProductsTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-buy-box"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bst-buy-box-gallery')) {
    class BstBuyBoxGallery extends HTMLElement {
      connectedCallback() {
        this.thumbList = this.querySelector('[data-thumb-list]');
        this.viewerImage = this.querySelector('[data-thumb-viewer-image]');
        this.slidesTrack = this.querySelector('[data-slides-track]');
        this.status = this.querySelector('[data-thumb-status]');
        this.prevButton = this.querySelector('[data-thumb-prev]');
        this.nextButton = this.querySelector('[data-thumb-next]');

        this.addEventListener('click', (event) => {
          const thumb = event.target.closest('[data-thumb-index]');
          if (thumb)
            this.selectThumb(thumb);

        });

        this.preloadedUrls = new Set();
        this.querySelectorAll('[data-thumb-index]').forEach((thumb) => {
          thumb.addEventListener('pointerenter', () => this.preloadThumb(thumb));
          thumb.addEventListener('focus', () => this.preloadThumb(thumb));
        });

        this.prevButton ?. addEventListener('click', () => this.scrollThumbs(-1));
        this.nextButton ?. addEventListener('click', () => this.scrollThumbs(1));
        this.thumbList ?. addEventListener('scroll', () => this.updateScrollState());

        window.addEventListener('resize', () => this.updateScrollState());
        this.updateScrollState();

// Mobile-only swipe track: whichever slide is centered in view marks
// the matching thumbnail active, the reverse of clicking a thumbnail.
        if (this.slidesTrack) {
          this.slideObserver = new IntersectionObserver((entries) => {
            const centered = entries.find((entry) => entry.isIntersecting);
            if (centered) 
              this.markActiveByIndex(centered.target.dataset.slideIndex);
            
          }, {
            root: this.slidesTrack,
            threshold: 0.6
          },);

          this.slidesTrack.querySelectorAll('[data-slide-index]').forEach((slide) => {
            this.slideObserver.observe(slide);
          });

// Infinite loop: once a swipe settles on a clone, silently jump to the
// identical real slide. Safari has no scrollend, so debounce scroll there.
          if ('onscrollend' in window) {
            this.slidesTrack.addEventListener('scrollend', () => this.wrapLoop());
          } else {
            this.slidesTrack.addEventListener('scroll', () => {
              clearTimeout(this.wrapTimer);
              this.wrapTimer = setTimeout(() => this.wrapLoop(), 120);
            }, {passive: true});
          }

          this.buildLoop();
        }

        this.closest('.bst-buy-box') ?. addEventListener('change', (event) => this.handleVariantChange(event));

// 'shopify:product:select' is StandardEvents.productSelect from '@shopify/events'
// (see assets/product-price.js) - hardcoded here since `{ javascript }` blocks
// in this theme aren't bundled with import-map resolution the way assets/*.js
// modules or <script type="module"> tags are (no other { javascript } block
// in this theme imports anything - importing that package here broke the whole
// script, including the pre-existing thumbnail/variant-swap behavior below)
        this.closest('.shopify-section') ?. addEventListener('shopify:product:select', (event) => this.handleProductSelect(event));

        const initialColor = this.getSelectedColorName();
        if (initialColor)
          this.filterByColor(initialColor);


        this.scheduleIdlePreload();
      }

// The sale badge depends on the selected variant's compare_at_price, so it
// needs to update when the shopper picks a different variant. The theme
// refetches the product page and dispatches this event (see variant-picker.js) -
// swap in the freshly rendered badges from that response rather than
// recomputing sale state on the client (keeps price-hiding app logic and
// currency formatting server-side, matching how product-price.js does it).
      handleProductSelect(event) {
        if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

        this.toggleLowStock(event.selectedOptions ?? this.readSelectedOptions(event.target));

        event.promise
          .then(({ detail }) => {
            if (!detail ?. html) return;

            const currentBadges = this.querySelector('[data-badges]');
            const newBadges = detail.html.querySelector('[data-badges]');

            if (newBadges) {
              if (currentBadges)
                currentBadges.replaceWith(newBadges);
              else
                this.viewerImage ?. insertAdjacentElement('beforebegin', newBadges);

            } else {
              currentBadges ?. remove();
            }

            // Same for the price row - compare-at price, the "Final Sale" label
            // under it and the "Save $X" badge all depend on the selected
            // variant being on sale, so swap in the freshly rendered row. The
            // price row lives outside this gallery element, so look it up from
            // the section.
            const currentPrice = this.closest('.shopify-section') ?. querySelector('.bst-buy-box__price');
            const newPrice = detail.html.querySelector('.bst-buy-box__price');
            if (currentPrice && newPrice) currentPrice.replaceWith(newPrice);

            // toggleLowStock already showed/hid the message from page-load
            // data; swap in the freshly rendered one too so it reflects any
            // stock change since then (it renders hidden when not low).
            const currentLowStock = this.closest('.shopify-section') ?. querySelector('[data-low-stock]');
            const newLowStock = detail.html.querySelector('[data-low-stock]');
            if (currentLowStock && newLowStock) currentLowStock.replaceWith(newLowStock);
          })
          .catch((error) => {
            if (error ?. name !== 'AbortError') console.warn('[bst-buy-box-gallery] Event promise rejected:', error);
          });
      }

// Shows/hides the low-stock message the moment a variant is picked, using
// the low-stock variant list rendered by snippets/bst-low-stock-message.liquid,
// instead of waiting for the section refetch. selectedOptions comes straight
// off the shopify:product:select event ({name, value} pairs).
      toggleLowStock(selectedOptions) {
        const message = this.closest('.shopify-section') ?. querySelector('[data-low-stock]');
        const dataScript = message ?. querySelector('[data-low-stock-variants]');
        if (!message || !dataScript || !Array.isArray(selectedOptions)) return;

        let data;
        try {
          data = JSON.parse(dataScript.textContent);
        } catch (error) {
          return;
        }

        const valueByName = Object.fromEntries(selectedOptions.map((option) => [option.name, option.value]));
        const selectedValues = data.options.map((name) => valueByName[name]);
        const isLow = data.lowStock.some((options) => options.every((value, index) => value === selectedValues[index]));

        message.hidden = !isLow;
      }

// Fallback for toggleLowStock - same lookup as variant-picker.js's
// getAllSelectedOptions().
      readSelectedOptions(picker) {
        const options = [];
        picker.querySelectorAll('select').forEach((select) => {
          const selected = select.selectedOptions[0];
          if (selected ?. dataset.optionName) options.push({name: selected.dataset.optionName, value: selected.value});
        });
        picker.querySelectorAll('fieldset input:checked').forEach((input) => {
          if (input.dataset.optionName) options.push({name: input.dataset.optionName, value: input.value});
        });
        return options;
      }

// Warms the cache for every visible thumbnail once the browser is idle,
// so even a shopper's first click (with no hover/focus to precede it)
// hits an already-fetched image. Runs after filterByColor so a hidden
// (wrong-color) thumbnail's image isn't fetched for nothing.
      scheduleIdlePreload() {
        const preloadVisible = () => {
          this.querySelectorAll('[data-thumb-index]').forEach((thumb) => {
            const listItem = thumb.closest('li');
            if (listItem ?. hidden) return;

            if (thumb.getAttribute('aria-current') === 'true') return;


            this.preloadThumb(thumb);
          });
        };

        if ('requestIdleCallback' in window) {
          requestIdleCallback(preloadVisible, {timeout: 2000});
        } else {
          setTimeout(preloadVisible, 1500);
        }
      }

      handleVariantChange(event) {
        const target = event.target;
        if (!(target instanceof HTMLInputElement)) return;
        

        const optionName = (target.dataset.optionName || '').toLowerCase();
        if (! optionName.includes('color') && ! optionName.includes('colour')) return;
        

        this.filterByColor(target.value);
      }

      getSelectedColorName() {
        const inputs = this.closest('.bst-buy-box') ?. querySelectorAll('input[data-option-name]') || [];

        for (const input of inputs) {
          const optionName = (input.dataset.optionName || '').toLowerCase();
          if ((optionName.includes('color') || optionName.includes('colour')) && input.checked) {
            return input.value;
          }
        }

        return '';
      }

// Product media is tagged in alt text with a "#color_<slug>" hashtag
// (e.g. "#color_Black-Charcoal", "#color_deep-dive") rather than free text,
// so matching means comparing slugs, not substring-searching alt text.
      slugifyColor(value) {
        return(value || '').trim().toLowerCase().replace(/[\s_]+/g, '-');
      }

      extractColorTag(alt) {
        const match = (alt || '').match(/#color_([a-z0-9-]+)/i);
        return match
          ? this.slugifyColor(match[1])
          : '';
      }

      filterByColor(colorName) {
        if (!this.thumbList) return;
        

        const thumbs = Array.from(this.querySelectorAll('[data-thumb-index]'));
        if (! thumbs.length) return;
        

        const slug = this.slugifyColor(colorName);
        const matches = slug
          ? thumbs.filter((thumb) => this.extractColorTag(thumb.dataset.imageAlt) === slug)
          : [];
        const hasMatches = matches.length > 0;

        thumbs.forEach((thumb) => {
          const listItem = thumb.closest('li');
          if (listItem) 
            listItem.hidden = hasMatches && ! matches.includes(thumb);
          
        });

        const slides = Array.from(this.slidesTrack ?. querySelectorAll('[data-slide-index]:not([data-slide-clone])') || []);
        const matchingSlides = slug
          ? slides.filter((slide) => this.extractColorTag(slide.dataset.imageAlt) === slug)
          : [];
        slides.forEach((slide) => {
          slide.hidden = hasMatches && ! matchingSlides.includes(slide);
        });

        this.buildLoop(hasMatches ? matches[0].dataset.thumbIndex : undefined);

        if (hasMatches)
          this.selectThumb(matches[0]);
        

        this.updateScrollState();
      }

// Shared by clicking a thumbnail and swiping the mobile slide track -
// keeps the thumbnail state, status message, and desktop viewer image
// in sync no matter which of the two the shopper actually used.
      markActiveByIndex(index) {
        const thumb = this.querySelector(`[data-thumb-index="${index}"]`);
        if (! thumb) return;
        

        this.querySelectorAll('[data-thumb-index]').forEach((btn) => {
          btn.setAttribute(
            'aria-current',
            btn === thumb
              ? 'true'
              : 'false'
          );
        });

        if (this.viewerImage) {
          this.viewerImage.src = thumb.dataset.imageUrl;
          this.viewerImage.srcset = thumb.dataset.imageSrcset;
          this.viewerImage.alt = thumb.dataset.imageAlt;
        }

        if (this.status) {
          this.status.textContent = thumb.getAttribute('aria-label');
        }

        this.revealThumb(thumb);
      }

// Keeps the active thumbnail in view as the shopper swipes the main track.
// Scrolls only the thumb list itself - scrollIntoView would also scroll the
// page - and only when the thumb is clipped, so tapping a visible thumb
// doesn't shift the strip under the shopper's finger.
      revealThumb(thumb) {
        if (!this.thumbList) return;

        const item = thumb.closest('li') || thumb;
        const list = this.thumbList;
        const isColumn = getComputedStyle(list).flexDirection === 'column';
        const listRect = list.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();

        const start = isColumn ? itemRect.top - listRect.top : itemRect.left - listRect.left;
        const end = isColumn ? itemRect.bottom - listRect.top : itemRect.right - listRect.left;
        const size = isColumn ? list.clientHeight : list.clientWidth;

        let delta = 0;
        if (start < 0) delta = start;
        else if (end > size) delta = end - size;
        if (!delta) return;

        list.scrollBy({
          top: isColumn ? delta : 0,
          left: isColumn ? 0 : delta,
          behavior: 'smooth'
        });
      }

// Warms the browser cache on hover/focus so the click swap in
// markActiveByIndex resolves against an already-fetched image instead
// of starting the request at click time.
      preloadThumb(thumb) {
        const url = thumb.dataset.imageUrl;
        if (!url || this.preloadedUrls.has(url)) return;

        this.preloadedUrls.add(url);
        const image = new Image();
        image.srcset = thumb.dataset.imageSrcset;
        image.src = url;
      }

      selectThumb(thumb) {
        this.markActiveByIndex(thumb.dataset.thumbIndex);

        const slide = this.slidesTrack ?. querySelector(`[data-slide-index="${
          thumb.dataset.thumbIndex
        }"]:not([data-slide-clone])`);
        if (slide) this.centerSlide(slide, 'smooth');
      }

// Clones every visible slide once before and once after the real set, so
// the first image can center with the last one peeking on its left and a
// fling in either direction never runs out of track. Swaps the pre-JS
// padding for the clones and repositions in one synchronous task, so the
// centered first image doesn't visibly move when the loop kicks in.
      buildLoop(activeIndex) {
        if (!this.slidesTrack) return;

        this.slidesTrack.querySelectorAll('[data-slide-clone]').forEach((clone) => {
          this.slideObserver ?. unobserve(clone);
          clone.remove();
        });

        const realSlides = Array.from(this.slidesTrack.querySelectorAll('[data-slide-index]:not([hidden])'));
        if (realSlides.length < 2) {
          this.slidesTrack.classList.remove('is-looped');
          return;
        }

        const makeClone = (slide) => {
          const clone = slide.cloneNode(true);
          clone.setAttribute('data-slide-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.inert = true;
          clone.querySelectorAll('img').forEach((img) => img.setAttribute('loading', 'lazy'));
          this.slideObserver ?. observe(clone);
          return clone;
        };

        this.slidesTrack.prepend(...realSlides.map(makeClone));
        this.slidesTrack.append(...realSlides.map(makeClone));
        this.slidesTrack.classList.add('is-looped');

        const currentIndex = activeIndex ?? this.querySelector('[data-thumb-index][aria-current="true"]') ?. dataset.thumbIndex;
        const target = realSlides.find((slide) => slide.dataset.slideIndex === currentIndex) || realSlides[0];
        this.centerSlide(target, 'instant');
      }

      wrapLoop() {
        if (!this.slidesTrack ?. classList.contains('is-looped')) return;

        const trackCenter = this.slidesTrack.scrollLeft + this.slidesTrack.clientWidth / 2;
        let closest = null;
        let closestDistance = Infinity;
        this.slidesTrack.querySelectorAll('[data-slide-index]:not([hidden])').forEach((slide) => {
          const distance = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - trackCenter);
          if (distance < closestDistance) {
            closest = slide;
            closestDistance = distance;
          }
        });

        if (!closest ?. hasAttribute('data-slide-clone')) return;

        const real = this.slidesTrack.querySelector(`[data-slide-index="${
          closest.dataset.slideIndex
        }"]:not([data-slide-clone])`);
        if (real) this.centerSlide(real, 'instant');
      }

      centerSlide(slide, behavior) {
        const left = slide.offsetLeft - (this.slidesTrack.clientWidth - slide.offsetWidth) / 2;
        this.slidesTrack.scrollTo({left, behavior});
      }

      scrollThumbs(direction) {
        if (!this.thumbList) return;
        

        const items = Array.from(this.thumbList.children).filter((item) => !item.hidden);
        const isColumn = getComputedStyle(this.thumbList).flexDirection === 'column';
        const [first, second] = items;

        let step = isColumn
          ? first ?. offsetHeight ?? 190
          : first ?. offsetWidth ?? 100;
        if (first && second) {
          step = isColumn
            ? second.offsetTop - first.offsetTop
            : second.offsetLeft - first.offsetLeft;
        }

        this.thumbList.scrollBy({
          top: isColumn
            ? step * direction
            : 0,
          left: isColumn
            ? 0
            : step * direction,
          behavior: 'smooth'
        });
      }

      updateScrollState() {
        if (!this.thumbList) return;
        
        const {scrollTop, scrollHeight, clientHeight} = this.thumbList;
        const atTop = scrollTop <= 0;
        const atBottom = scrollTop + clientHeight >= scrollHeight - 1;

        this.thumbList.classList.toggle('is-at-end', atBottom);
        this.prevButton ?. classList.toggle('is-hidden', atTop);
        this.nextButton ?. classList.toggle('is-hidden', atBottom);
      }
    }

    customElements.define('bst-buy-box-gallery', BstBuyBoxGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bst-features-carousel')) {
    class BstFeaturesCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-features-track]');
        this.prevButton = this.querySelector('[data-features-prev]');
        this.nextButton = this.querySelector('[data-features-next]');

        this.prevButton?.addEventListener('click', () => this.scrollByCard(-1));
        this.nextButton?.addEventListener('click', () => this.scrollByCard(1));
        this.track?.addEventListener('scroll', () => this.updateNavState());

        window.addEventListener('resize', () => this.updateNavState());
        this.updateNavState();
      }

      scrollByCard(direction) {
        if (!this.track) return;
        const card = this.track.querySelector('[data-features-card]');
        const gap = 8;
        const step = card ? card.offsetWidth + gap : this.track.clientWidth;
        this.track.scrollBy({ left: step * direction, behavior: 'smooth' });
      }

      updateNavState() {
        if (!this.track) return;
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const atStart = scrollLeft <= 0;
        const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;

        this.prevButton?.classList.toggle('is-hidden', atStart);
        this.nextButton?.classList.toggle('is-hidden', atEnd);
      }
    }

    customElements.define('bst-features-carousel', BstFeaturesCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bst-reviews-carousel')) {
    class BstReviewsCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-reviews-track]');
        this.prevButton = this.querySelector('[data-reviews-prev]');
        this.nextButton = this.querySelector('[data-reviews-next]');

        this.prevButton?.addEventListener('click', () => this.scrollByCard(-1));
        this.nextButton?.addEventListener('click', () => this.scrollByCard(1));
        this.track?.addEventListener('scroll', () => this.updateNavState());

        window.addEventListener('resize', () => this.updateNavState());
        this.updateNavState();
      }

      scrollByCard(direction) {
        if (!this.track) return;
        const card = this.track.querySelector('.bst-review-card');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = card ? card.offsetWidth + gap : this.track.clientWidth;
        this.track.scrollBy({ left: step * direction, behavior: 'smooth' });
      }

      updateNavState() {
        if (!this.track) return;
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const atStart = scrollLeft <= 0;
        const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;

        this.prevButton?.classList.toggle('is-hidden', atStart);
        this.nextButton?.classList.toggle('is-hidden', atEnd);
      }
    }

    customElements.define('bst-reviews-carousel', BstReviewsCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
